import { Tabs as T } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { surface } from "./foundation";
export const Tabs = surface(T.Root, "tabs", "min-w-0");
export const TabsTrigger = surface(T.Trigger, "tabs-trigger", "cyra-tab");
export const TabsContent = surface(T.Content, "tabs-content", "min-w-0 pt-4 outline-none");
export function TabsList({
  variant: _variant,
  className,
  ...props
}: ComponentProps<typeof T.List> & { variant?: "default" | "line" }) {
  return <T.List {...props} data-slot="tabs-list" className={cn("cyra-tabs", className)} />;
}
